module.exports = __webpack_public_path__ + "SamsungOne-300C.c82e2375a5f4a77d66b3.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-300C.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-300C.ttf
// module chunks = styles